import * as React from "react";
import { List, ListItem, ListItemText, Typography } from "@mui/material";
import { PositionBadge } from "./PositionBadge";
import { EmptyState } from "./EmptyState";

export interface ExecutionTimelineItem {
  id: string;
  label: string;
  status: string;
}

interface ExecutionTimelineProps {
  items: ExecutionTimelineItem[];
  emptyMessage?: string;
}

/**
 * Lists execution records in exactly the order the backend returned
 * them - `ExecutionOrderDto` carries no timestamp field, so this
 * component never re-sorts by time (there is no time to sort by) and
 * never claims the list is chronological.
 */
export function ExecutionTimeline({
  items,
  emptyMessage = "No execution history reported by the backend.",
}: ExecutionTimelineProps): React.JSX.Element {
  if (items.length === 0) {
    return <EmptyState message={emptyMessage} />;
  }

  return (
    <List dense aria-label="Execution timeline">
      <Typography variant="caption" color="text.secondary" sx={{ px: 2 }}>
        Order not guaranteed chronological — the backend reports no timestamp for these records.
      </Typography>
      {items.map((item) => (
        <ListItem key={item.id} divider>
          <ListItemText primary={item.label} secondary={item.id} />
          <PositionBadge status={item.status} />
        </ListItem>
      ))}
    </List>
  );
}
